import React from 'react';
import { ClientContext } from '~/services';

export function useParseHyperlinkText() {
    const { client } = React.useContext(ClientContext);

    function parseHyperlinkText(text?: null | string) {
        if (!text) return null;

        // regex to match hyperlink markdown format
        const regex = /\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g;
        const elements: (string | JSX.Element)[] = [];

        let lastIndex = 0;
        const matches = Array.from(text.matchAll(regex));
        matches.forEach((match) => {
            const [fullMatch, linkText, url] = match;
            const matchStart = match.index ?? 0;

            // add text before this match
            if (lastIndex < matchStart) {
                elements.push(text.slice(lastIndex, matchStart));
            }

            try {
                const parsedUrl = new URL(url);
                const isDomainAllowed = client.settings?.hyperlink_domain_allowlist?.some(
                    (domain: string) => parsedUrl.hostname.endsWith(domain)
                );
                const isValidProtocol = parsedUrl.protocol === 'https:';

                if (isDomainAllowed && isValidProtocol) {
                    elements.push(
                        <a href={url} rel="noreferrer" target="_blank" key={matchStart}>
                            {linkText}
                        </a>
                    );
                } else {
                    // render full text if URL does not pass validation
                    elements.push(fullMatch);
                }
            } catch {
                // render full text if URL cannot be parsed
                elements.push(fullMatch);
            }

            lastIndex = matchStart + fullMatch.length;
        });

        // add any remaining text after last match
        if (lastIndex < text.length) {
            elements.push(text.slice(lastIndex));
        }

        return <span>{elements}</span>;
    }

    return parseHyperlinkText;
}
